"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RelationshipOptionsOverlayContentModule = /** @class */ (function () {
    function RelationshipOptionsOverlayContentModule() {
    }
    return RelationshipOptionsOverlayContentModule;
}());
exports.RelationshipOptionsOverlayContentModule = RelationshipOptionsOverlayContentModule;
